import { generateUniqueId, stripTimestampAndExtension } from '@/assets/js/Utilities';
import Cookies from "js-cookie";
import $ from "jquery";


export default class ColourMatch {
	constructor() {
		this.blockName = 'colour-match';
		this.worker = null;
		this.quality = 1;
		this.maxWidth = 512;
		this.maxHeight = 512;

		this.initialPresets = [
			{
				name: 'Correlative 1 Pure',
				id: 7,
				values: {
					ColorSpace: 1,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: 100,
					PercentShadingShift: 0,
					ExtraShading: true,
					ScaleRatherThanClip: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Correlative 2 Pure',
				id: 8,
				values: {
					ColorSpace: 0,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: 100,
					PercentShadingShift: 0,
					ExtraShading: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
		];

		this.presets = [
			{
				name: 'Correlative 1 (Auto)',
				id: 1,
				values: {
					ColorSpace: 1,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: -1,
					PercentShadingShift: 50,
					ExtraShading: true,
					ScaleRatherThanClip: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Correlative 2 (Auto)',
				id: 2,
				values: {
					ColorSpace: 0,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: -1,
					PercentShadingShift: 50,
					ExtraShading: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Linear 1',
				id: 3,
				values: {
					ColorSpace: 1,
					CrossCovarianceLimit: 0,
					ReshapingIterations: 0,
					PercentSaturationShift: 100,
					PercentShadingShift: 100,
					ExtraShading: false,
					ScaleRatherThanClip: false,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Linear 2',
				id: 4,
				values: {
					ColorSpace: 0,
					CrossCovarianceLimit: 0,
					ReshapingIterations: 0,
					PercentSaturationShift: 100,
					PercentShadingShift: 100,
					ExtraShading: false,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Correlative 1 Saturated',
				id: 5,
				values: {
					ColorSpace: 1,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: 100,
					PercentShadingShift: 50,
					ExtraShading: true,
					ScaleRatherThanClip: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Correlative 2 Saturated',
				id: 6,
				values: {
					ColorSpace: 0,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: 100,
					PercentShadingShift: 50,
					ExtraShading: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Correlative 1 Full',
				id: 9,
				values: {
					ColorSpace: 1,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: 100,
					PercentShadingShift: 100,
					ExtraShading: true,
					ScaleRatherThanClip: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
			{
				name: 'Correlative 2 Full',
				id: 10,
				values: {
					ColorSpace: 0,
					CrossCovarianceLimit: 50,
					ReshapingIterations: 1,
					PercentSaturationShift: 100,
					PercentShadingShift: 100,
					ExtraShading: true,
					PercentTint: 100,
					PercentModified: 100,
				}
			},
		];
	}

	async addBlock(blockNum = lutify.blocks.length, selectedSampleFile = false) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		await this.initWorker();
		this.addRegenerateButton($(element));
		// this.addExclamationMark($(element));

		$(element)
			.find(".range_slider")
			.on("input", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler(e);
			});

		$(element)
			.find(".range_value")
			.on("change", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler(e);
			});

		// $(element)
		// 	.find(".lut-selector__items-container > span")
		// 	.on("click", (e, animate) => this.onPresetSelection(e.currentTarget, $(element), animate));

		$(element)
			.find(".lut-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				this.togglePresetSelector($(e.currentTarget));
			});

		$(element)
			.find(".btn-reset-block")
			.on("click", e => this.resetBlock($(element)));

		$(element).on("click", e => {
			e.stopImmediatePropagation();
			// UI.hideLUTtemplates();
			if (!lutify.getActiveBlock().sampleFile) return;
			if (!luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`]) return;
			if (luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`].length == 0) return;
			this.showPreviews();
		});

		$(element).find('.colour-match-more-btn').on('click', async e => {
			vm.$store.dispatch('App/setBlockLoading', true);

			let lutArray = luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`];

			if (!lutArray || lutArray.length == 0) {
				this.removeLoadMoreButton();
				await this.createInitialPresetPreviews();
				await this.createPresetPreviews();
				vm.$store.dispatch('App/setBlockLoading', false);
				return;
			}

			if (lutArray && lutArray.length == this.initialPresets.length) {
				this.removeLoadMoreButton();
				await this.createPresetPreviews();
				vm.$store.dispatch('App/setBlockLoading', false);
				return;
			}
		});

		$(element).find('.btn-advanced').on('click', e => {
			let state = e.currentTarget.getAttribute('data-state');
			if (state == 'collapsed') {
				$(element).find('.advanced-content-container').slideDown(100);
				$(element).find('.btn-advanced i.collapse').show();
				$(element).find('.btn-advanced i.expand').hide();
				e.currentTarget.setAttribute('data-state', 'expanded')
			} else {
				$(element).find('.advanced-content-container').slideUp(50);
				$(element).find('.btn-advanced i.expand').show();
				$(element).find('.btn-advanced i.collapse').hide();
				e.currentTarget.setAttribute('data-state', 'collapsed')
			}
		});

		$(element).find('#apply-colour-match').on('click', () => {
			if (!lutify.getActiveBlock().sampleFile) {
				vm.$root.projectTree.openColourMatchModal(vm.$store.state.Projects.currentFile, 'applyColourMatch');
			} else this.apply();
		})

		$(element).find('.sample-selector').on('click', e => {
			vm.$root.projectTree.openColourMatchModal(vm.$store.state.Projects.currentFile, 'updateColourMatchSample');
		});

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "colourMatch",
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			presetId: null,
			sampleFile: null,
			targetPixels: null,
			samplePixels: null,
			opacity: 100,
			isVideo: vm.$store.state.UI.video.isLoaded,
			sampleVideoTime: vm.$store.state.UI.video.currentTimeMs,

			values: {
				ColorSpace: 0,
				CrossCovarianceLimit: 50,
				ReshapingIterations: 1,
				PercentSaturationShift: -1,
				PercentShadingShift: 50,
				ExtraShading: true,
				ScaleRatherThanClip: true,
				PercentTint: 100,
				PercentModified: 100,
			}
		});

		this.setPresetList($(element));
		$(element).find(".lut-selector__items-container").hide();

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		// $(element)
		// 	.find(`.control-selector__items-container > span[data-color-space="1"]`)
		// 	.trigger("click", [false]);

		if (!vm.$store.state.UI.showAddMatchTooltip && vm.$store.getters['Projects/allMatches'].length == 0) {
			vm.$store.dispatch('UI/setAddMatchTooltip', "Please load a reference image first, then save it as a Match using the option above to start using the Colour Match tool");
		}

		if (!Cookies.get("ColourMatchToolNotice")) {
			UI.hideModal();
			UI.showModal(UI.modals.blocks.warnings.colourMatchTool);
		}
	}

	setPresetList($block) {
		let presets = [...this.initialPresets, ...this.presets];

		presets.forEach(preset => {
			let el = document.createElement('span');
			el.innerHTML = preset.name;
			el.setAttribute('data-preset-id', preset.id);
			el.addEventListener('click', e => {
				this.onPresetSelection(e.currentTarget, preset);
			});

			$block.find('.lut-selector__items-container').append(el)
		});
	}

	addRegenerateButton($element) {
		let icon = document.createElement('i')
		icon.setAttribute('class', 'btn-block-regenerate material-icons')
		icon.setAttribute('data-tippy-content', 'Regenerate')
		icon.innerHTML = 'loop'
		icon.addEventListener('click', async () => {
			UI.appendBlockLoadingSpinner($element)

			this.apply();

			UI.removeBlockLoadingSpinner($element)
		})
		$element.find('.header-container .controls-wrapper').prepend(icon)
	}

	// addExclamationMark($element) {
	// 	let icon = document.createElement('i');
	// 	icon.setAttribute('class', 'btn-block-needs-update material-icons hide');
	// 	icon.setAttribute('data-tippy-content', 'You have changed the position or a value of Colour Match. This might affect the result. Click this icon to re-calculate the result.');
	// 	icon.innerHTML = 'error_outline';
	// 	let icon2 = icon.cloneNode(true);
	//
	// 	[icon, icon2].forEach(item => {
	// 		item.addEventListener('click', () => {
	//
	// 		});
	// 	});
	// 	$element.find('.header-container .controls-wrapper').prepend(icon);
	// 	$element.find('.apply-colour-match-container').append(icon2);
	// }

	async setTargetPixels() {
		let blockNum = blocks.getBlockIndex_byBlockNum(lutify.getActiveBlock().blockNum);
		let passes = blocks.getAllPassesToBlock(blockNum);
		let targetImg = lutify.getIDTLMTimage(passes);

		let compressedImage = await readAndCompressImage(
			loader.dataURLtoFile(targetImg, `target.jpg`),
			{
				quality: this.quality,
				maxWidth: this.maxWidth,
				maxHeight: this.maxHeight,
			}
		);

		let compressedImageURL = URL.createObjectURL(compressedImage)
		lutify.getActiveBlock().targetPixels = await this.getPixels(compressedImageURL);
		URL.revokeObjectURL(compressedImageURL);
	}

	async apply(initial = false) {
		try {
			vm.$store.dispatch('App/setBlockLoading', true);
			$('#blocks-container--outer').addClass('--overlay');
			$('#project-navigator-container').addClass('--overlay');
			$('#filmstrip-container .thumbnail-container').addClass('--overlay');

			// $(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');
			vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

			if (lutify.getActiveBlock().isVideo) {
				lutify.getActiveBlock().sampleVideoTime = vm.$store.state.UI.video.currentTimeMs;
			}

			await this.setTargetPixels();

			if (initial) {
				await this.createInitialPresetPreviews();
			} else {
				let LUT = await this.getLut();
				let loadedLUTs = await luts.load([LUT]);
				let pass = gpu.createLUTPass(loadedLUTs[0].texture);
				pass.uid = lutify.getActiveBlock().passes[0].uid;
				let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
				gpu.composer.passes[index] = pass;
				lutify.getActiveBlock().passes[0] = pass;
			}

			if ($(`#previews-list-container .colour-match-more-btn[data-category="ColourMatch-${lutify.getActiveBlock().passes[0].uid}"]`).length == 0) {
				this.addLoadMoreButton();
				UI.getActiveBlock().click();
			}

			gpu.render();
			vm.$store.dispatch("Loader/showProgressBar", false);
		} finally {
			vm.$store.dispatch('App/setBlockLoading', false);
			$('#blocks-container--outer').removeClass('--overlay');
			$('#project-navigator-container').removeClass('--overlay');
			$('#filmstrip-container .thumbnail-container').removeClass('--overlay');
			vm.$store.dispatch("Loader/showProgressBar", false);
		}
	}

	async createInitialPresetPreviews() {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

		setTimeout(() => {
			UI.togglePreviewsContainer();
			lutPreviewer.showPlaceholderPreviews()
		}, 50);

		if (typeof luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`] == "undefined") luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`] = [];

		for await (const [key, preset] of this.initialPresets.entries()) {
			let LUT = await this.getLut(preset.values);
			let loadedLUTs = await luts.load([LUT]);
			loadedLUTs[0].control = 'LUTcontrols';
			loadedLUTs[0].category = `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`;
			loadedLUTs[0].title = preset.name;
			loadedLUTs[0].presetId = preset.id;

			luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`].push(loadedLUTs[0]);

			lutPreviewer.createPreviews(loadedLUTs, false, undefined, 'colourMatch');
		}

		vm.$store.dispatch("Loader/showProgressBar", false);
		UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
		lutPreviewer.removePlaceholderPreviews();
		UI.getActiveBlock().click();
	}

	async createPresetPreviews() {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

		setTimeout(() => {
			UI.togglePreviewsContainer();
			lutPreviewer.showPlaceholderPreviews()
		}, 50);

		if (typeof luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`] == "undefined") luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`] = [];

		for await (const [key, preset] of this.presets.entries()) {
			let LUT = await this.getLut(preset.values);
			let loadedLUTs = await luts.load([LUT]);
			loadedLUTs[0].control = 'LUTcontrols';
			loadedLUTs[0].category = `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`;
			loadedLUTs[0].title = preset.name;
			loadedLUTs[0].presetId = preset.id;

			luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`].push(loadedLUTs[0]);

			lutPreviewer.createPreviews(loadedLUTs, false, undefined, 'colourMatch');
		}

		vm.$store.dispatch("Loader/showProgressBar", false);
		UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
		lutPreviewer.removePlaceholderPreviews();
		UI.getActiveBlock().click();
	}

	async initWorker() {
		if (this.worker) return;
		this.worker = new Worker("/assets/vendor/colourMatch/CTworker.1.5.js?v=1.0.1");
		await new Promise(resolve => {
			this.worker.addEventListener('message', e => {
				resolve();
			});
		})
	}

	getLut(values, targetPixels, samplePixels) {
		if (!values) values = lutify.getActiveBlock().values;
		if (!targetPixels) targetPixels = lutify.getActiveBlock().targetPixels;
		if (!samplePixels) samplePixels = lutify.getActiveBlock().samplePixels;

		return new Promise(resolve => {
			this.worker.postMessage([values, targetPixels, samplePixels]);
			this.worker.onmessage = e => {
				let decodedContent = new TextDecoder().decode(e.data.lut_copy);
				let file = new File([decodedContent], "colour-match.cube", { type: "text/plain"});
				// console.log('[WORKER][COLOUR MATCH] completed');
				resolve(file);
			}
		})
	}

	addPass() {
		let pass = gpu.createRenderPass();
		gpu.addPassToComposer(pass, "toMiddle");
		return pass;
	}

	togglePresetSelector($el) {
		let itemsContainer = $el.siblings(".lut-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	onPresetSelection(el, preset) {
		let category = 'ColourMatch-' + lutify.getActiveBlock().passes[0].uid;

		if ($(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.id}"]`).length > 0) {
			$(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.id}"]`).trigger('click');
		} else {
			this.setBlockValues($(UI.getActiveBlock()), preset);
			$(UI.getActiveBlock()).find('#apply-colour-match').trigger('click');

			let id = el.getAttribute('data-preset-id');
			let name = $(el).html();

			this.updatePresetList(id, name);
		}
	}

	updatePresetList(id, name) {
		let $lutSelector = $(UI.getActiveBlock()).find(".lut-selector");
		$lutSelector.find(".lut-selector__items-container").hide();
		$lutSelector.find(".selected-lut-name").html(name);

		$lutSelector
			.find(`.lut-selector__items-container .--selected`)
			.removeClass("--selected");

		$lutSelector
			.find(`.lut-selector__items-container span[data-preset-id="${id}"]`).addClass("--selected");
	}

	sliderHandler(e) {
		if (e.originalEvent) {
			lutify.getActiveBlock().presetId = 0;
			this.updatePresetList(lutify.getActiveBlock().presetId, 'Custom');
		}

		let $element = $(e.currentTarget);
		// $(UI.getActiveBlock()).find('.btn-block-needs-update').removeClass('hide');

		let value = parseFloat($element.val());
		let control = $element.data("control");

		if ($element.hasClass("range_value")) {
			if (value > parseInt($element.attr("max"))) {
				value = parseInt($element.attr("max"));
				$element.val(value);
			}
			if (value < parseInt($element.attr("min"))) {
				value = parseInt($element.attr("min"));
				$element.val(value);
			}
		}

		if ($element.hasClass("range_slider"))
			$element
				.closest(".block-sliders-container")
				.find(".range_value")
				.val(value);
		else
			$element
				.closest(".block-sliders-container")
				.find(".range_slider")
				.val(value);

		if (value == -1) {
			$element
				.closest(".block-sliders-container")
				.find(".slider-value-auto")
				.removeClass('hide');
		} else {
			$element
				.closest(".block-sliders-container")
				.find(".slider-value-auto")
				.addClass('hide');
		}

		lutify.getActiveBlock().values[control] = value;
	}

	async applyChanges($block, values, blockData) {
		let preset = [...this.initialPresets, ...this.presets].find(preset => preset.id === blockData.presetId);
		preset = this.comparePresetValues(values, preset);
		this.setBlockValues($block, preset);
		// $(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');
		this.updatePresetList(preset.id, preset.name);

		if (blockData.sampleFile) {
			if (!vm.$store.getters["Projects/assetById"](blockData.sampleFile.id, blockData.sampleFile.type)) {
				vm.$snackbar('Selected Match for Colour Match is no longer available. Please select a new one or otherwise remove the AI Colour Extract tool.', 'error', {
					timeout: -1,
					contentClass: 'text-center',
				});
				return;
			}
			await this.setSampleFile(blockData.sampleFile);
			if (blockData.isVideo) {
				lutify.getActiveBlock().sampleVideoTime = blockData.sampleVideoTime;
				document.querySelector("#video").currentTime = blockData.sampleVideoTime;
				vm.$store.dispatch('UI/setVideoCurrentTime', blockData.sampleVideoTime);

				// wait for video frame to be rendered
				await new Promise(resolve => {
					setTimeout(() => {
						resolve();
					}, 500);
				});
			}
			await this.apply();
			// $block.find(".opacity-input").val(parseInt(blockData.opacity));
			// $block.find(".opacity-input").trigger("change");
			$block.find(".controls-wrapper .switch > input").trigger("click");
			window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;
			if (blockData.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${blockData.blendingMode}"]`).trigger("click");
		}
	}

	comparePresetValues(blockValues, preset) {
		if (!preset) return {
			name: 'Custom',
			id: 0,
			values: blockValues
		};

		let isDifferent = false;

		Object.entries(blockValues).forEach(key => {
			if (blockValues[key] !== preset.values[key]) isDifferent = true;
		})

		if (isDifferent) {
			return {
				name: 'Custom',
				id: 0,
				values: blockValues
			}
		} else return preset;
	}

	setBlockValues($block, preset) {
		lutify.getActiveBlock().presetId = preset.id;
		lutify.getActiveBlock().values = { ...preset.values };

		Object.keys(preset.values).forEach(key => {
			let control = $block.find(`[data-control="${key}"]`);
			if (!control) return;

			if (control.attr('type') == 'range') {
				control.val(preset.values[key]);
				control.trigger("input");
			} else {
				control.attr('checked', preset.values[key]);
				control.trigger('change');
			}
		});
	}

	async setSampleFile(file) {
		this.removeLoadMoreButton();
		lutify.getActiveBlock().passes[0].uid = generateUniqueId();

		blocks.checkSwitchHandler($(UI.getActiveBlock()));

		lutify.getActiveBlock().sampleFile = {
			id: file.id,
			type: file.type,
		};

		let match = vm.$store.getters["Projects/assetById"](file.id, file.type);
		let matchStoreData = await lutify.fetchMatch(match);

		let compressedImage = await readAndCompressImage(
			matchStoreData.imageIDTLMT,
			{
				quality: this.quality,
				maxWidth: this.maxWidth,
				maxHeight: this.maxHeight,
			}
		);

		let compressedImageURL = URL.createObjectURL(compressedImage)
		lutify.getActiveBlock().samplePixels = await this.getPixels(compressedImageURL);
		URL.revokeObjectURL(compressedImageURL);

		this.setSampleFileUI(matchStoreData.blob, match.name);
	}

	async getPixels(targetImage) {
		let img = new Image();
		img.src = targetImage;
		await img.decode();

		let size = lutify.getConstrainedImageSize(img.width, img.height);
		UI.colourMatchCanvas.setSize(size.width, size.height);
		UI.colourMatchCanvas.el.getContext('2d').drawImage(img, 0, 0, size.width, size.height);
		return UI.colourMatchCanvas.el.getContext('2d').getImageData(0, 0, size.width, size.height);
	}

	setSampleFileUI(imageBlob, name) {
		if (!lutify.getActiveBlock()) return;
		let block = UI.getActiveBlock();
		let $block = $(block);

		let imgSrc = URL.createObjectURL(imageBlob);
		let imgElement = document.createElement('img');
		imgElement.setAttribute('src', imgSrc);
		imgElement.setAttribute('class', 'thumbnail');
		imgElement.setAttribute('data-tippy-content', 'Click to change a Match');
		$block.find('.sample-selector img, .select-asset-btn').remove();
		$block.find('.sample-selector').prepend(imgElement);

		name = stripTimestampAndExtension(name);
		$block.find('.sample-selector .name').text(`Selected Match: ${name}`);
	}

	resetBlock($element) {
		let value = $element.find('.lut-selector__items-container').attr('data-default-value');
		// $element.find(`[data-color-space="${value}"]`).trigger('click');
	}

	showPreviews() {
		lutify.selectedPreviewCategory = `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`;

		UI.togglePreviewsContainer();
		UI.updatePreviewsTab('Colour Match');
		lutPreviewer.switchCanvases(`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`);
		// UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);

		lutPreviewer.cloneMainComposerPasses();
		lutPreviewer.addPass('LUTcontrols', `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`, undefined, lutify.getActiveBlock().blendingMode);

		lutPreviewer.render();
		setTimeout(() => lutPreviewer.render(), 50); // because of visual glitch
	}

	removeLoadMoreButton() {
		$(`#previews-list-container .colour-match-more-btn[data-category="ColourMatch-${lutify.getActiveBlock().passes[0].uid}"]`).remove();
		$(UI.getActiveBlock()).find('.colour-match-more-btn').closest('.colour-match-generate-container').addClass('hide');
	}

	addLoadMoreButton() {
		this.showPreviews();

		$(UI.getActiveBlock()).find('.colour-match-more-btn').closest('.colour-match-generate-container').removeClass('hide');

		let content = document.getElementById("previews-list-container");
		let element = document.createElement("div");
		element.className = `list-item thumbnail-canvas colour-match-more-btn`;
		element.innerHTML = '<span class="modal-btn --primary">More options</span>';
		element.addEventListener("click", e => {
			$(UI.getActiveBlock()).find('.colour-match-more-btn').trigger('click');
		});
		element.setAttribute("data-category", `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`);
		element.setAttribute("style", "display: none;");

		content.appendChild(element);
	}
}
